export default __webpack_public_path__ + "static/media/Start Kit 35k.5c1542b5.jpg";